var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"feature_view_wrapper"},[_c('Feature',{attrs:{"keyFeatList":_vm.keyFeatList}}),_c('Footer'),_c('FootBanner',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPc && !_vm.isIOS),expression:"!isPc && !isIOS"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }